import { FC } from "react";
import styles from "./OfferPreview.module.scss";
import cn from "classnames";
import {
  OFFER_GET_INSTRUCTION,
  OFFER_GET_PDF
} from "~/pages/questionnaires/v2/customer/api/apiUrls";

const baseURL = import.meta.env.VITE_APP_API_URL;

interface OfferResultProps {
  creationDate: Date | null;
  toggle: () => void;
  isLoadingConfirmAgreement: boolean;
  clientId: string;
}

export const OfferResult: FC<OfferResultProps> = ({ creationDate, clientId }) => {
  return (
    <div className={styles.containerLast}>
      {creationDate ? (
        <>
          <p className={styles.title}>
            Ваша оферта создана и будет размещена на вашей платежной странице.
          </p>
          <div className={styles.actions}>
            <div className={styles.buttonGroup}>
              <a
                href={baseURL + OFFER_GET_PDF + `?questionnaire_uid=${clientId}`}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(styles.button)}
              >
                Скачать оферту
              </a>
              <a
                href={baseURL + OFFER_GET_INSTRUCTION}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(styles.button)}
              >
                Скачать инструкцию
              </a>
            </div>
          </div>
        </>
      ) : (
        <>
          <p className={styles.title}>
            Вы можете отредактировать оферту и загрузить окончательный файл.
          </p>
          <p className={styles.warningMessage}>
            Мы взяли ваши данные из анкеты. Если обнаружили ошибки, то внесите изменения на
            предыдущих шагах.
          </p>
        </>
      )}
    </div>
  );
};
